import { HeaderNav } from "../components/HeaderNav";
import { KineticHero } from "../components/KineticHero";
import { MarqueeTicker } from "../components/MarqueeTicker";
import { PortfolioGallery } from "../components/PortfolioGallery";
import { ServicesSection } from "../components/ServicesSection";
import { Reveal } from "../components/Reveal";
import { WhatsAppRequestForm } from "../components/WhatsAppRequestForm";
import { FooterLegal } from "../components/FooterLegal";
import { FloatingWhatsApp } from "../components/FloatingWhatsApp";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1712696767893-fec648e0b387?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwyfHxhcmNoaXRlY3R1cmFsJTIwYmx1ZXByaW50JTIwcGxhbiUyMGRyYXdpbmclMjB0ZWNobmljYWwlMjBjb25zdHJ1Y3Rpb258ZW58MHx8fHdoaXRlfDE3OTE0ODU4NzN8MA&ixlib=rb-4.1.0&q=85";

const STATS = [
  ["4", "anos de atuação"],
  ["40+", "projetos aprovados"],
  ["4", "disciplinas integradas"],
];

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#FBFBFC] text-slate-900">
      <HeaderNav />
      <main>
        <KineticHero />
        <MarqueeTicker />
        <PortfolioGallery />
        <ServicesSection />

        <section id="sobre" className="mx-auto grid max-w-7xl scroll-mt-24 items-center gap-14 px-5 py-24 sm:px-8 sm:py-32 lg:grid-cols-2">
          <Reveal className="relative">
            <div className="absolute -left-4 -top-4 h-full w-full border border-[#C05621]" aria-hidden="true" />
            <img src={ABOUT_IMG} alt="Desenho técnico arquitetônico" loading="lazy" className="relative aspect-[4/3] w-full object-cover" />
          </Reveal>
          <Reveal delay={0.15}>
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#C05621]">O escritório</p>
            <h2 className="font-display mt-4 text-3xl font-extrabold uppercase leading-[1.02] tracking-tight text-slate-900 sm:text-4xl">
              Precisão de cálculo, desenho de arquitetura
            </h2>
            <p className="mt-6 text-base leading-relaxed text-slate-600">
              A ZARI ENGENHARIA nasceu em Terra Roxa com uma convicção: um bom projeto
              é aquele que une estética, economia de obra e segurança estrutural.
              Trabalhamos com disciplinas integradas — arquitetônico, estrutural,
              elétrico e hidrossanitário — para que nada se perca entre o papel e a execução.
            </p>
            <div className="mt-10 grid grid-cols-3 gap-px border border-slate-900/10 bg-slate-900/10">
              {STATS.map(([n, label]) => (
                <div key={label} className="bg-white p-5">
                  <p className="font-mono text-2xl font-bold text-slate-900 sm:text-3xl">{n}</p>
                  <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.15em] text-slate-500">{label}</p>
                </div>
              ))}
            </div>
          </Reveal>
        </section>

        <WhatsAppRequestForm />
      </main>
      <FooterLegal />
      <FloatingWhatsApp />
    </div>
  );
}
